<template>
  <div>
    <div>
      <vue-toastr ref="notificationToast"></vue-toastr>
      <div class="ibox box-primary">
        <div class="ibox-title with-border"><h2 class="box-title">{{ title }}</h2></div>
        <div class="ibox-content">

          <input name="send_test_customers"
                 type="hidden"
                 id="send_test_customers"
                 class="form-control"
                 v-model="record.send_test_customers">

          <div v-if="isAdmin" class="form-group">
            <label class="control-label">Mandant</label>
            <Select2 v-model="record.client_id" :options="clients"/>
          </div>
          <div class="form-group">
            <label>Prospektbenennung</label>
            <br>
            <input name="name"
                   type="text"
                   id="name"
                   class="form-control"
                   v-model="record.name">
          </div>

          <div class="form-group">
            <label>Überschrift</label>
            <br>
            <input name="title"
                   type="text"
                   id="title"
                   class="form-control"
                   v-model="record.title">
          </div>
          <div class="form-group">
            <input name="use_date"
                   type="checkbox"
                   id="use_date"
                   v-model="record.use_date">&nbsp;
            <label>Anzeigezeitraum wählen</label>
          </div>
          <div v-if="record.use_date" class="form-group">
            <h3>Anzeigezeitraum <a class="fa fa-question-circle" v-tippy="{ placement : 'right' }"
                                   content="Zeitraum, in dem der Content im Marketing-Slider angezeigt werden soll."></a>
            </h3>
            <div class="col-md-6">
              <label>Von:</label>
              <br>
              <input name="date_start"
                     type="datetime-local"
                     id="date_start"
                     class="form-control"
                     :required="record.use_date"
                     v-model="record.date_start">
            </div>
            <div class="col-md-6">
              <label>Bis:</label>
              <br>
              <input name="date_end"
                     type="datetime-local"
                     id="date_end"
                     class="form-control"
                     :required="record.use_date"
                     v-model="record.date_end">
            </div>
          </div>
          <div class="form-group">
            <label>Slider Vorschaubild <a class="fa fa-question-circle" v-tippy="{ placement : 'right' }"
                                          content="Das empfohlene Bildmaß liegt im Seitenverhältnis 4:5 oder bei 380x476 Pixeln. Maximal 10MB."></a></label>
            <br>
            <div v-if="!record.media_src" style="background: #eeeeee; border-radius: 15px; min-height: 50px">
              <file-pond
                  name="image"
                  ref="pond"
                  label-idle="Datei auswählen..."
                  :allow-multiple="false"
                  :accepted-file-types="'image/jpeg, image/png, image/webp'"
                  maxFileSize="10MB"
                  :server="server"
                  @processfile="afterUpload"
                  :disabled="disabled"
              />
            </div>
            <div v-else>
              <div class="col-md-12">
                <div class="row" style="display: flex; align-items: center">
                  <div class="col-md-1">
                    <button class="btn btn-danger float-right" style="margin-top: 50%;" slot="browse-btn"
                            content="Bild entfernen"
                            @click="removeImage()"
                            :disabled="disabled"
                            v-tippy="{ placement : 'right' }"><i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="col-md-11">
                    <div style="display: flex; justify-content: center;  background: #eeeeee; border-radius: 15px ">
                      <img :src="record.media_src" style="max-width: 100%; max-height: 350px;">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div v-for="(element,index) in record.pages">
              <advertisement-page :index="index" :advertisement="record" :record="element"></advertisement-page>
            </div>
          </div>
          <br>
          <div class="col-md-12">
            <button type="button" class="btn btn-success col-md-12" @click="addNewElement"
                    :disabled="!record.title">
              <i class="fa fa-plus"></i> Neues Medium hinzufügen
            </button>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="form-group">
            <label>Testkundennummern <a class="fa fa-question-circle" v-tippy="{ placement : 'right' }"
                                        content="Durch Kommata getrennt, sichtbar ab App 4.3"></a></label>
            <br>
            <input name="test_customers"
                   type="text"
                   id="test_customers"
                   class="form-control"
                   v-model="record.test_customers">
          </div>

          <button type="button" class="btn btn-secondary" @click="submit"
                  :disabled="!record.title || submitting">Speichern und schließen
          </button>
          <button type="button" class="btn btn-secondary" @click="submitAndSendCampaignCustomers"
                  :disabled="!record.title || submitting">Speichern und an Testkundennummern aussenden
          </button>
          <spinner v-if="submitting"></spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import Spinner from "../common/spinner/Spinner";
import AdvertisementPage from "./AdvertisementPage.vue";

export default {
  name: 'AdvertisementForm',
  components: {
    AdvertisementPage,
    Spinner,
    Modal,
    VueToastr
  },
  methods: {
    afterUpload(error, file) {

      console.log(file.serverId);

      const response = JSON.parse(file.serverId);

      this.record.media_src = response.content_url;

      this.$parent.$forceUpdate();
      this.$forceUpdate();
    },
    removeImage() {
      this.record.media_src = null;
    },
    addNewElement() {
      this.record.pages.push({
        marks: []
      });
      this.$forceUpdate();
      this.$parent.$forceUpdate();
    },
    async submitAndSendCampaignCustomers() {
      this.record.send_test_customers = true;

      if (this.record.client_id == null) {
        return; //TODO: Message to user
      }

      this.submitting = true;
      try {
        const res = await axios.patch('/backend/advertisements/' + this.record.id, this.record);
        window.location = '/backend/advertisements/' + res.data + '/edit';
      } catch (e) {
        console.log(e);
      } finally {
        this.submitting = false;
      }
    },
    async submit() {
      if (this.record.client_id == null) {
        return; //TODO: Message to user
      }

      this.submitting = true;
      try {
        await axios.patch('/backend/advertisements/' + this.record.id, this.record);
        window.location = '/backend/advertisements/';
      } catch (e) {
        console.log(e);
      } finally {
        this.submitting = false;
      }

    }
  },
  data() {
    return {
      record: null,
      submitting: false,
      files: [],
      server: {
        url: '/api/content-hub/pdf/upload',
        process: {
          url: '',
          method: 'POST',
          withCredentials: true,
          headers: {},
          timeout: 7000,
          ondata: (formData) => {
            formData.append('id', this.record.id);
            formData.append('client_id', this.record.client_id);
            formData.append('scale_width', 380);
            formData.append('scale_height', 476);
            return formData;
          },
        }
      },
    };
  },
  props: ['clients', 'isAdmin', 'dbRecord', 'user', 'title', 'disabled'],
  mounted() {
    this.record = this.dbRecord;
    this.record.send_test_customers = false;
    if (!Array.isArray(this.record.pages) || this.record.pages === 0) this.record.pages = [];
    this.$parent.$forceUpdate();
    this.$forceUpdate();
  }
}
</script>

<style scoped>
</style>
<style>
.ckeditor-wrapper .ck-content {
  min-height: 300px;
}

.filepond--root {
  font-size: 1.5rem;
}

label {
  margin-bottom: 6px;
  margin-top: 9px;
}
</style>
